// -------------------------------声明-------------------------------------------
// <auto-generated>
//     此文件是自动生成的文件，对这个文件的任何修改在下次自动生成的时候都会丢失。
//     模板名称：\TTFiles\TS\Entity\Service.tt
// </auto-generated>
// ------------------------------------------------------------------------------
import { AccountInfoDTO } from '../../../../../com/MetaPattern/APP/MDA/User/AccountInfoDTO';
import { post, get } from '../../../../../../libs/com/MetaPattern/Product/IDE/Util/Request';
class LoginByPasswordDTO {
  loginCertificate: string;
  password: string;

  public toJson(): any {
    const json: any = {};
    json.LoginCertificate = this.loginCertificate;
    json.Password = this.password;
    return json;
  }
}
/**
 * 元型账户服务 服务类
 * 元型账户服务
 */
export class MDAAccountService {
  static async LoginByPasswordAsync(loginCertificate: string, password: string): Promise<AccountInfoDTO | null> {
    return new Promise((resolve, reject) => {
      const dto = new LoginByPasswordDTO();
      dto.loginCertificate = loginCertificate;
      dto.password = password;
      post('metapattern-ide-mda/service/mdaaccountservice/loginbypassword', dto.toJson())
        .then((response: any) => {
          let result: AccountInfoDTO | null = null;
          if (response) {
            result = AccountInfoDTO.Create(response);
          }
          resolve(result);
        })
        .catch(error => {
          // TODO : 格式化错误返回
          reject(error);
        });
    });
  }

  static async GetAccountInfoAsync(): Promise<AccountInfoDTO | null> {
    return new Promise((resolve, reject) => {
      get('metapattern-ide-mda/service/mdaaccountservice/getaccountinfo')
        .then((response: any) => {
          let result: AccountInfoDTO | null = null;
          if (response) {
            result = AccountInfoDTO.Create(response);
          }
          resolve(result);
        })
        .catch(error => {
          // TODO : 格式化错误返回
          reject(error);
        });
    });
  }
}
